"use client";
import React from "react";
import Image from "next/image";
import { Box, Center, Grid, GridItem, HStack, Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import { FEATURE_CONSTANTS } from "./constants";

const FeaturesComponent = () => {
  const { FEATURES, IMAGE } = FEATURE_CONSTANTS;
  const TextVariant = useTextVariant();
  return (
    <Grid
      gap={{ base: 4, lg: 12 }}
      templateColumns={{
        base: "repeat(1, 1fr)",
        md: "repeat(5, 1fr)",
      }}
    >
      <GridItem colSpan={{ base: 1, md: 3 }}>
        <Center height={"full"}>
          <Box
            h={{ base: "300px", sm: "350px" }}
            w={{ base: "100%", sm: "80%", md: "80%" }}
            position="relative"
            alignSelf={"center"}
          >
            <Image
              src={IMAGE}
              alt="IntroImg"
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
              placeholder="blur"
              loading="lazy"
            />
          </Box>
        </Center>
      </GridItem>
      <GridItem colSpan={{ base: 1, md: 2 }}>
        <Stack gap={10}>
          {FEATURES.map((feature, index) => (
            <HStack key={index} gap={4}>
              <Image
                alt="Point"
                src={feature.image}
                width={40}
                height={20}
                style={{ paddingTop: "4px" }}
              />
              <Stack gap={4}>
                <Text variant={TextVariant}>{feature.title}</Text>
                <Text variant={TextVariant} color="text.100">
                  {feature.description}
                </Text>
              </Stack>
            </HStack>
          ))}
        </Stack>
      </GridItem>
    </Grid>
  );
};

export default FeaturesComponent;
